import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import { Mosaic, MosaicWindow, updateTree } from "react-mosaic-component";
import { motion, useAnimation } from "framer-motion";
import { message } from "antd"; // ✅ only if using Ant Design
import Axios from "../Axios";
import { bin } from "d3";
import { nanoid } from "nanoid"; // small fast unique id
import socket from "../socket-io";
import consts from "../consts";
// Your layouts array and createChartTile() function here...

// Simple unique ID generator
// function createChartTile(prefix = "chart") {
//     console.log(prefix + "_" + Math.random().toString(36).substr(2, 9), 'Perfix');

//     return prefix + "_" + Math.random().toString(36).substr(2, 9);

// }

function createChartTile(id, i, compact = false) {
  const uniqueId = `${id}_${i}`; // unique chart id
  return compact ? `${uniqueId}-compact` : uniqueId;
}
const layouts = [
  { key: "1c", layout: createChartTile("1c", "0") },

  {
    key: "2c-l1",
    layout: {
      direction: "row",
      first: createChartTile("2c-l1-first", "0"),
      second: createChartTile("2c-l1-second", "1"),
    },
  },
  {
    key: "2c-l2",
    layout: {
      direction: "column",
      first: createChartTile("2c-l2-first", "0", true),
      second: createChartTile("2c-l2-second", "1", true),
    },
  },

  {
    key: "3c-l1",
    layout: {
      direction: "column",
      first: createChartTile("3c-l1-first", "0", true),
      second: {
        direction: "row",
        first: createChartTile("3c-l1-second", "1", true),
        second: createChartTile("3c-l1-third", "2", true),
      },
    },
  },
  {
    key: "3c-l2",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("3c-l2-first", "0", true),
        second: createChartTile("3c-l2-second", "1", true),
      },
      second: createChartTile("3c-l2-third", "2", true),
    },
  },
  {
    key: "3c-l3",
    layout: {
      direction: "row",
      first: createChartTile("3c-l3-first", "0", false),
      second: {
        direction: "column",
        first: createChartTile("3c-l3-second", "1", true),
        second: createChartTile("3c-l3-third", "2", true),
      },
    },
  },
  {
    key: "3c-l4",
    layout: {
      direction: "row",
      first: {
        direction: "column",
        first: createChartTile("3c-l4-first", "0", true),
        second: createChartTile("3c-l4-second", "1", true),
      },
      second: createChartTile("3c-l4-third", "2", false),
    },
  },
  {
    key: "3c-l5",
    layout: {
      direction: "row",
      first: createChartTile("3c-l5-first", "0", false),
      second: {
        direction: "row",
        first: createChartTile("3c-l5-second", "1", false),
        second: createChartTile("3c-l5-third", "2", false),
        splitPercentage: 50, // optional; ensures 2nd and 3rd are equal
      },
      splitPercentage: 33.33, // 👈 ensures first one takes 1/3
    },
  },
  // 4-Chart Layouts
  {
    key: "4c-l1",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("4c-l1-first", "0", true),
        second: createChartTile("4c-l1-second", "1", true),
      },
      second: {
        direction: "row",
        first: createChartTile("4c-l1-third", "2", true),
        second: createChartTile("4c-l1-fourth", "3", true),
      },
    },
  },
  {
    key: "4c-l2",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("4c-l2-first", "0", true),
        second: {
          direction: "row",
          first: createChartTile("4c-l2-second", "1", true),
          second: createChartTile("4c-l2-third", "2", true),
          splitPercentage: 50, // equal second/third
        },
        splitPercentage: 33.33, // first row = 1/3 each
      },
      second: createChartTile("4c-l2-fourth", "3", true),
      splitPercentage: 50, // upper row (3 charts) 75% height, last one 25%
    },
  },

  {
    key: "4c-l3",
    layout: {
      direction: "column",
      first: createChartTile("4c-l3-first", "0", true),
      second: {
        direction: "row",
        first: createChartTile("4c-l3-second", "1", true),
        second: {
          direction: "row",
          first: createChartTile("4c-l3-third", "2", true),
          second: createChartTile("4c-l3-fourth", "3", true),
          splitPercentage: 50,
        },
        splitPercentage: 33.33, // 3 equal bottom charts
      },
      splitPercentage: 50, // top = 25% height, bottom = 75%
    },
  },

  {
    key: "4c-l4",
    layout: {
      direction: "row",
      first: createChartTile("4c-l4-first", "0", false),
      second: {
        direction: "column",
        first: createChartTile("4c-l4-second", "1", true),
        second: {
          direction: "column",
          first: createChartTile("4c-l4-third", "2", true),
          second: createChartTile("4c-l4-fourth", "3", true),
          splitPercentage: 50, // equal 3rd & 4th
        },
        splitPercentage: 33.33, // 2nd column split evenly
      },
      splitPercentage: 50, // equal left/right width
    },
  },

  {
    key: "4c-l5",
    layout: {
      direction: "row",
      first: {
        direction: "column",
        first: createChartTile("4c-l5-first", "0", true),
        second: {
          direction: "column",
          first: createChartTile("4c-l5-second", "1", true),
          second: createChartTile("4c-l5-third", "2", true),
          splitPercentage: 50,
        },
        splitPercentage: 33.33, // top/bottom equal columns
      },
      second: createChartTile("4c-l5-fourth", "3", false),
      splitPercentage: 50, // equal left/right width
    },
  },

  // Multi-Chart Layouts (mc)
  {
    key: "mc-l1",
    layout: {
      direction: "column",
      first: createChartTile("0"),
      second: {
        direction: "row",
        first: createChartTile("1"),
        second: {
          direction: "row",
          first: createChartTile("2"),
          second: {
            direction: "row",
            first: createChartTile("3"),
            second: createChartTile("4"),
          },
        },
      },
    },
  },
  {
    key: "mc-l2",
    layout: {
      direction: "row",
      first: {
        direction: "column",
        first: createChartTile("0"),
        second: {
          direction: "column",
          first: createChartTile("1"),
          second: {
            direction: "column",
            first: createChartTile("2"),
            second: createChartTile("3"),
          },
        },
      },
      second: createChartTile("4"),
    },
  },
  {
    key: "mc-l3",
    layout: {
      direction: "row",
      first: createChartTile("0"),
      second: {
        direction: "column",
        first: createChartTile("1"),
        second: {
          direction: "column",
          first: createChartTile("2"),
          second: {
            direction: "column",
            first: createChartTile("3"),
            second: createChartTile("4"),
          },
        },
      },
    },
  },
  {
    key: "mc-l4",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("0"),
        second: {
          direction: "column",
          first: createChartTile("1"),
          second: createChartTile("2"),
        },
      },
      second: {
        direction: "row",
        first: createChartTile("3"),
        second: {
          direction: "row",
          first: createChartTile("4"),
          second: createChartTile("5"),
        },
      },
    },
  },
  {
    key: "mc-l5",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("0"),
        second: {
          direction: "row",
          first: createChartTile("1"),
          second: createChartTile("2"),
        },
      },
      second: {
        direction: "row",
        first: createChartTile("3"),
        second: {
          direction: "row",
          first: createChartTile("4"),
          second: createChartTile("5"),
        },
      },
    },
  },
  {
    key: "mc-l6",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("0"),
        second: {
          direction: "column",
          first: createChartTile("1"),
          second: createChartTile("2"),
        },
      },
      second: {
        direction: "row",
        first: createChartTile("3"),
        second: {
          direction: "column",
          first: createChartTile("4"),
          second: createChartTile("5"),
        },
      },
    },
  },
  {
    key: "mc-l7",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: {
          direction: "column",
          first: createChartTile("0"),
          second: createChartTile("1"),
        },
        second: createChartTile("2"),
      },
      second: {
        direction: "row",
        first: {
          direction: "column",
          first: createChartTile("3"),
          second: createChartTile("4"),
        },
        second: createChartTile("5"),
      },
    },
  },
  {
    key: "mc-l8",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("0"),
        second: createChartTile("1"),
      },
      second: {
        direction: "row",
        first: createChartTile("2"),
        second: {
          direction: "row",
          first: createChartTile("3"),
          second: createChartTile("4"),
        },
      },
    },
  },
  {
    key: "mc-l9",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("0"),
        second: {
          direction: "row",
          first: createChartTile("1"),
          second: createChartTile("2"),
        },
      },
      second: {
        direction: "row",
        first: createChartTile("3"),
        second: createChartTile("4"),
      },
    },
  },
  {
    key: "mc-l10",
    layout: {
      direction: "column",
      first: {
        direction: "row",
        first: createChartTile("0"),
        second: {
          direction: "row",
          first: createChartTile("1"),
          second: createChartTile("2"),
        },
      },
      second: {
        direction: "column",
        first: {
          direction: "row",
          first: createChartTile("3"),
          second: {
            direction: "row",
            first: createChartTile("4"),
            second: createChartTile("5"),
          },
        },
        second: {
          direction: "row",
          first: createChartTile("6"),
          second: {
            direction: "row",
            first: createChartTile("7"),
            second: createChartTile("8"),
          },
        },
      },
    },
  },
];

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
  // On first load, try to get layout from localStorage
  const storedLayout = localStorage.getItem("selectedLayout");
  const storedActiveKey = localStorage.getItem("activeLayoutKey");
  const [openShowOrderBook, setshowOrderBookk] = useState(false);
  const tradeChartRef = useRef({});
  const initialLayout = storedLayout
    ? JSON.parse(storedLayout)
    : layouts[0].layout;
  const initialActiveLay = storedActiveKey || "1c";
  const [chat, setChat] = useState(false);

  const [currentLayout, setCurrentLayout] = useState(initialLayout);
  const [activeLay, setActiveLay] = useState(initialActiveLay);
  const [totalProfit, setTotalProfit] = useState(0);
  //isRunning
  const [isRunning, setIsRunning] = useState(false);
  console.log(initialLayout, "activeLay");
  const [mode, setMode] = useState("chart");
  const [activeFtpage, setActiveFtpage] = useState();

  //show asset drawer
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  //animated control
  const controls = useAnimation();

  // loader for chart
  const [loadingCharts, setLoadingCharts] = useState([]);

  console.log(loadingCharts, "loadingCharts");

  // Remove tile using context setter

  const pruneEmptyBranches = (node) => {
    if (!node) return null;

    // Leaf node with no first/second
    if (!node.first && !node.second) return node;

    // Recursively prune children
    const first = pruneEmptyBranches(node.first);
    const second = pruneEmptyBranches(node.second);

    // If both branches are gone, prune this node too
    if (!first && !second) return null;

    return { ...node, first, second };
  };

  const handleRemove = (path) => {
    setCurrentLayout((prev) => {
      let updated = updateTree(prev, [{ path, spec: { $set: null } }]);

      // Recursively prune empty branches
      updated = pruneEmptyBranches(updated);

      // If tree is empty, reset to default
      if (!updated) return layouts[0].layout;

      return updated;
    });
  };

  // Whenever current layout changes, save to localStorage
  useEffect(() => {
    localStorage.setItem("selectedLayout", JSON.stringify(currentLayout));
    localStorage.setItem("activeLayoutKey", activeLay);
  }, [currentLayout, activeLay]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setActiveLay("1c");
        setCurrentLayout("1c_0");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // check on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const switchLayout = (key) => {
    const selected = layouts.find((l) => l.key === key);
    if (selected) {
      setActiveLay(selected.key);
      setCurrentLayout(selected.layout);
    }
  };
  const [tradeHistory, setTradeHistory] = useState([]);
  const [positions, setPositions] = useState([]);
  const [type, setType] = useState("binary");
  const [wallet, setWallet] = useState({});
  const [escrow, setEscrow] = useState(0);
  const [pending, setPending] = useState([]);
  const [openOrders, setOpenOrders] = useState([]);
  const [futureLeverage, setFutureLeverage] = useState(0);
  const [triggerForexOrders, setTriggerForexOrders] = useState(false);

  useEffect(() => {
    if (pending.length > 0) {
      const ids = pending.map((i) => i?._id);
      const closedTrade = tradeHistory.filter((i) => !ids.includes(i?._id));
    } else if (type === "pending" || type === "close") {
      const ids = tradeHistory.filter((i) => i?.status === "Pending");
      setPending(ids);
    }
  }, [tradeHistory, openOrders]);
  const getWallet = async () => {
    try {
      const { data } = await Axios.post(
        "/users/getWallet",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      if (data?.success) {
        setWallet(data?.result[0]);
      } else {
        setWallet({});
      }
    } catch (e) {
      setWallet({});
    }
  };
  const getTradeHistory = async () => {
    try {
      console.log(type, "newType");
      const headers = {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      };

      // Pending/close tabs should show both forex and commodities trades.
      if (type === "pending" || type === "close") {
        const [forexRes, commoditiesRes] = await Promise.allSettled([
          Axios.post("/users/getTradeHistory", { type, role: "user" }, headers),
          Axios.post(
            "/users/getCommoditiesTradeHistory",
            { type, role: "user" },
            headers,
          ),
        ]);

        const forexData =
          forexRes?.status === "fulfilled" ? forexRes?.value?.data : null;
        const commoditiesData =
          commoditiesRes?.status === "fulfilled"
            ? commoditiesRes?.value?.data
            : null;

        const forexRows = forexData?.success ? forexData?.result || [] : [];
        const commodityRows = commoditiesData?.success
          ? commoditiesData?.result || []
          : [];

        // Deduplicate by _id while preserving order.
        const mergedRows = [...forexRows, ...commodityRows].filter(
          (row, idx, arr) => arr.findIndex((x) => x?._id === row?._id) === idx,
        );

        console.log(mergedRows, "TypeTradeHistory");
        setTradeHistory(mergedRows);
      } else {
        const { data } = await Axios.post(
          "/users/getTradeHistory",
          { type, role: "user" },
          headers,
        );

        if (data?.success) {
          console.log(data?.result, "TypeTradeHistory");
          setTradeHistory(data?.result);
        } else {
          setTradeHistory([]);
        }
      }
    } catch (e) {
      setTradeHistory([]);
      console.log(e);
    }
  };

  const getPositions = async () => {
    try {
      console.log(type, "newType");
      const { data } = await Axios.post(
        "/ownTrade/getOpenPositions",
        { type },
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      if (data?.success) {
        setPositions(data?.result || []);
      } else {
        setPositions([]);
      }
    } catch (e) {
      setPositions([]);
      console.log(e);
    }
  };

  const getFutureLeverge = async () => {
    try {
      const { data } = await Axios.post(
        "/ownTrade/getFutureLeverage",
        { type: "cross" },
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      if (data?.success) {
        setFutureLeverage(data?.result);
      } else {
        setFutureLeverage(0);
      }
    } catch (e) {
      setFutureLeverage(0);
      console.log(e);
    }
  };

  const [percent, setPercent] = useState(0);
  const getWinningPercent = async () => {
    try {
      const { data } = await Axios.post("/get-profitPerc", {}, {});
      if (data?.success) {
        setPercent(data?.result?.percent);
      } else {
        setPercent(0);
      }
    } catch (e) {
      setPercent(0);
      console.log(e);
    }
  };

  // const getForexOpenOrders = async () => {
  //   try {
  //     const { data } = await Axios.post(
  //       "/users/getTradeHistory",
  //       { type: "pending" },
  //       {
  //         headers: {
  //           Authorization: localStorage.getItem("nzanzi"),
  //         },
  //       },
  //     );
  //     if (data?.success) {
  //       setOpenOrders(data?.result);
  //     } else {
  //       setOpenOrders([]);
  //     }
  //   } catch (e) {
  //     setOpenOrders([]);
  //     console.log(e);
  //   }
  // };

  // useEffect(() => {
  //   getForexOpenOrders();
  // }, [triggerForexOrders]);

  useEffect(() => {
    getWinningPercent();
  }, []);

  useEffect(() => {
    console.log(type, "TWRwerr");
    getFutureLeverge();
    // if (!localStorage.getItem("nzanzi")) return;
    getPositions();
    getTradeHistory();
    getWallet();
    // let interval = null;
    // if (type === "close" || type === "pending") {
    //   interval = setInterval(() => {
    //     getTradeHistory();
    //     getWallet();
    //   }, 10000);
    // }
  }, [type]);

  useEffect(() => {
    socket.emit("getOpenOrders", {
      access_token: localStorage.getItem("nzanzi"),
    });
    socket.on("getOpenOrders", (data) => {
      // getForexOpenOrders();
      getPositions();
    });
    return () => {
      socket.off("getOpenOrders");
    };
  }, []);

  const defaultTabs = [
    {
      uid: nanoid(), // 🔥 permanent unique identifier
      key: "0",
      title: "BTC/USDT",
      typ: "Crypto",
      imgSrc: `${consts.BackendUrl}/images/BTC.png`,
      chartType: "binary",
    },
  ];
  // https://img.icons8.com/color/25/bitcoin--v1.png
  // 1️⃣ Load from localStorage on first render
  const [tabs, setTabs] = useState(() => {
    const saved = localStorage.getItem("tabs");

    if (saved) {
      const parsed = JSON.parse(saved);

      // 🔥 Ensure every tab has uid
      return parsed.map((t) => ({
        ...t,
        uid: t.uid || nanoid(), // create uid if missing
      }));
    }

    // no saved tabs → fix defaultTabs keys/uid
    return defaultTabs.map((t, index) => ({
      ...t,
      key: index.toString(),
    }));
  });

  const [isMatched, setIsMatched] = useState(true);
  const [isMatchedIndex, setIsMatchedIndex] = useState(0);

  // 2️⃣ Store tabs whenever they change
  useEffect(() => {
    localStorage.setItem("tabs", JSON.stringify(tabs));
  }, [tabs]);

  const [activeKey, setActiveKey] = useState(tabs[0].key); // active tab

  const prevActiveKey = useRef(activeKey);

  useEffect(() => {
    if (!tabs?.length) return;

    const activeIdx = tabs.findIndex((t) => t.key === activeKey);
    const prevActiveIdx = tabs.findIndex(
      (t) => t.key === prevActiveKey.current,
    );

    // ✅ Conditions:
    // - both indexes valid
    // - new active index is greater than matched index
    // - the matched tab itself isn't currently active
    // - the new active tab isn't already at matched index
    if (
      activeIdx !== -1 &&
      prevActiveIdx !== -1 &&
      isMatchedIndex !== -1 &&
      activeIdx > isMatchedIndex &&
      activeIdx !== isMatchedIndex &&
      prevActiveIdx !== activeIdx // 🚫 prevent swapping with itself
    ) {
      setTabs((prevTabs) => {
        const updatedTabs = [...prevTabs];

        // Swap previous active tab with new active tab
        const temp = updatedTabs[prevActiveIdx];
        updatedTabs[prevActiveIdx] = updatedTabs[activeIdx];
        updatedTabs[activeIdx] = temp;

        return updatedTabs;
      });
    }

    prevActiveKey.current = activeKey;
  }, [activeKey, isMatchedIndex, tabs]);

  useEffect(() => {
    if (localStorage.getItem("activeLayoutKey") === "1c" && tabs.length) {
      setActiveKey(tabs[0].key);
      setActiveFtpage(tabs[0]);
    }
  }, [initialActiveLay, tabs]);

  const removeTab = (targetKey) => {
    setTabs((prevTabs) => {
      const newTabs = prevTabs.filter((tab) => tab.key !== targetKey);

      // ✅ Update active key safely
      if (activeKey === targetKey) {
        const targetIndex = prevTabs.findIndex((tab) => tab.key === targetKey);
        const newActiveTab =
          newTabs[targetIndex] || newTabs[targetIndex - 1] || newTabs[0];
        setActiveKey(newActiveTab ? newActiveTab.key : null);
      }

      return newTabs;
    });
  };

  const onEdit = (targetKey, action) => {
    console.log(targetKey, action, "targetKey");

    if (action === "add") {
      // addTab();
    } else if (action === "remove") {
      removeTab(targetKey);
    }
  };

  // Add new asset + tab
  // ➕ Add new tab and auto reindex keys
  const addAsset = (
    name,
    typ,
    chartType,
    imgSrc,
    istab = false,
    isMedium = false,
  ) => {
    setTabs((prevTabs) => {
      if (typ === "future") {
        const newTab = {
          uid: nanoid(),
          title: name,
          chartType,
          typ,
          imgSrc,
          key: "0",
        };
        setActiveKey("0");
        return [newTab];
      }

      // 🧹 If adding a normal pair → remove all future tabs
      if (typ !== "future") {
        prevTabs = prevTabs.filter((t) => t.typ !== "future");
      }

      const exists = prevTabs.some(
        (tab) =>
          tab.title.toLowerCase() === name.toLowerCase() &&
          tab.chartType === chartType,
      );
      if (exists) {
        if (isMedium) {
          return prevTabs;
        }
        message.warning("Asset already added!");
        return prevTabs;
      }

      if (prevTabs.length >= 5) {
        message.warning("You can only open up to 5 assets at a time.");
        return prevTabs;
      }

      if (istab && prevTabs.length >= 3) {
        message.warning("You can only open up to 3 assets at a time.");
        return prevTabs;
      }

      const activeIdx = prevTabs.findIndex((t) => t.key === activeKey);
      const insertionIndex = activeIdx === -1 ? prevTabs.length : activeIdx;

      // NEW TAB
      const newTab = {
        uid: nanoid(), // 🔥 permanent ID
        title: name,
        chartType,
        typ,
        imgSrc,
        key: null,
      };

      const newTabs = [...prevTabs];
      newTabs.splice(insertionIndex, 0, newTab);

      // 🔥 DO NOT TOUCH uid
      const reindexed = newTabs.map((tab, index) => ({
        ...tab,
        key: index.toString(),
      }));

      setActiveKey(insertionIndex.toString());
      return reindexed;
    });
  };

  // layout chart size adjustment
  const [isCompact, setIsCompact] = useState(false);

  // useEffect(() => {
  //   if (!activeLay) return;

  //   const mosaicTile = document.querySelector(".mosaic-tile");
  //   let compact = true;

  //   if (mosaicTile) {
  //     const computedStyle = getComputedStyle(mosaicTile);
  //     // Compare the left value
  //     if (computedStyle.left === "50%" || computedStyle.left === "50px") {
  //       compact = false; // prevent compact for this specific layout
  //     }
  //   }

  //   // Optional: keep previous exceptions
  //   if (["1c", "2c-l1"].includes(activeLay)) {
  //     compact = false;
  //   }

  //   setIsCompact(compact);
  // }, [activeLay]);
  // ;

  // useEffect(() => {
  //   if (!activeLay) return;

  //   const mosaicTile = document.querySelector(".mosaic-tile");
  //   let compact = true; // default: compact for multi-chart layouts

  //   // Only skip compact if inset exactly matches "0% 0% 0% 50%"
  //   if (mosaicTile && mosaicTile.style.inset === "0% 0% 0% 50%") {
  //     compact = false;
  //   }

  //   // Still force non-compact for single chart or special cases
  //   if (["1c", "2c-l1"].includes(activeLay)) {
  //     compact = false;
  //   }

  //   setIsCompact(compact);
  // }, [activeLay]);

  //           useEffect(() => {
  //     if (!activeLay) return;

  //     // chart count from first character
  //     const count = parseInt(activeLay[0]);

  //     // 🧠 this is the key change
  //     // treat 1c and 2c-l1 as normal (not compact)
  //     if (["1c", "2c-l1",].includes(activeLay)) {
  //       setIsCompact(false);
  //     } else {
  //       setIsCompact(!isNaN(count) && count >= 2);
  //     }
  //   }, [activeLay]);

  useEffect(() => {
    if (!activeLay) return;

    const normalLayouts = ["1c", "2c-l1"];
    const compactLayouts = [
      "2c-l2",
      "3c-l1",
      "3c-l2",
      "3c-l3",
      "3c-l4",
      "3c-l5",
      "4c-l1",
      "4c-l2",
      "4c-l3",
      "4c-l4",
      "4c-l5",
      "mc-l1",
      "mc-l2",
      "mc-l3",
      "mc-l4",
      "mc-l5",
      "mc-l6",
      "mc-l7",
      "mc-l8",
      "mc-l9",
      "mc-l10",
    ];

    if (normalLayouts.includes(activeLay)) {
      setIsCompact(false);
    } else if (compactLayouts.includes(activeLay)) {
      setIsCompact(true);
    } else {
      setIsCompact(false);
    }
  }, [activeLay]);

  const handleRemovePlotLines = (
    ids = ["tp-line", "sl-line", "bet-line"],
    currencyPair,
  ) => {
    const chart = tradeChartRef?.current[currencyPair]?.chart;
    console.log(chart, tradeChartRef?.current, "chart close");
    if (!chart) return;

    const yAxis = chart.yAxis[0];
    ids.forEach((id) => {
      try {
        yAxis.removePlotLine(id);
        console.log(`🧹 Removed plot line: ${id}`);
      } catch (e) {
        console.warn(`⚠️ Could not remove ${id}:`, e.message);
      }
    });
  };
  return (
    <LayoutContext.Provider
      value={{
        currentLayout,
        controls,
        tradeHistory,
        setTriggerForexOrders,
        percent,
        getTradeHistory,
        openOrders,
        positions,
        getPositions,
        wallet,
        getWallet,
        getFutureLeverge,
        futureLeverage,
        escrow,
        setEscrow,
        type,
        setType,
        loadingCharts,
        setTotalProfit,
        totalProfit,
        switchLayout,
        setCurrentLayout,
        activeLay,
        handleRemove,
        setTabs,
        tabs,
        addAsset,
        onEdit,
        activeKey,
        setActiveKey,
        showDrawer,
        openDrawer,
        onClose,
        isCompact,
        isRunning,
        setIsRunning,
        setIsMatched,
        isMatched,
        setIsMatchedIndex,
        isMatchedIndex,
        prevActiveKey,
        tradeChartRef,
        handleRemovePlotLines,
        setChat,
        chat,
        openShowOrderBook,
        setshowOrderBookk,
        setMode,
        activeFtpage,
        mode,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => useContext(LayoutContext);
